import { useMediaQuery } from '@chakra-ui/react'

const useCustomMediaQuery = () => {
    // could have used useBreakpoint but that's more expensive than a simple media query
    const [isMobile] = useMediaQuery(['(max-width: 1023px)'], {
        fallback: [false],
    })

    return [isMobile]
}

export default useCustomMediaQuery
